import { render, staticRenderFns } from "./serviceForbidden.vue?vue&type=template&id=ccbad12a&scoped=true"
import script from "./serviceForbidden.vue?vue&type=script&lang=js"
export * from "./serviceForbidden.vue?vue&type=script&lang=js"
import style0 from "./serviceForbidden.vue?vue&type=style&index=0&id=ccbad12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbad12a",
  null
  
)

export default component.exports